import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { defineMessages, useIntl } from 'react-intl';
import { Button, Icon, Label } from 'semantic-ui-react';

const messages = defineMessages({
  currentFilters: {
    id: 'Current filters applied',
    defaultMessage: 'Current filters applied',
  },
  clearFilters: {
    id: 'Clear filters',
    defaultMessage: 'Clear filters',
  },
  text: {
    id: 'Text',
    defaultMessage: 'Text',
  },
});

/**
 * A list of active filtered values and controls to clear those filters.
 *
 */
const FilterList = (props) => {
  const {
    data = {},
    facets = {},
    setFacets,
    isEditMode,
    cleanFilters,
    setSearchText,
    removeSearchQuery,
  } = props;
  const definedFacets = data.facets || [];

  const totalFilters = definedFacets.filter(
    ({ field }) =>
      field &&
      Object.keys(facets).includes(field.value) &&
      !isEmpty(facets[field.value]),
  ).length;

  const searchText = facets.SearchableText && facets.SearchableText.trim();

  const intl = useIntl();

  return totalFilters || searchText ? (
    <div className="filter-listing">
      <div className="filter-list-header">
        <div className="filter-list-title">
          {intl.formatMessage(messages.currentFilters)}:{' '}
          {totalFilters + (searchText ? 1 : 0)}
        </div>
        <Button
          type="button"
          icon
          basic
          compact
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            if (!isEditMode) {
              cleanFilters ? cleanFilters() : setFacets({});
            }
          }}
        >
          <Icon name="trash" />
          {intl.formatMessage(messages.clearFilters)}
        </Button>
      </div>
      <div className="filter-list-content">
        {searchText && (
          <div className="filter-list-group">
            <span className="label-title">
              {intl.formatMessage(messages.text)}
            </span>
            <Label size="small">
              <Icon
                name="delete"
                onClick={() => {
                  setSearchText('');
                  removeSearchQuery();
                }}
              />
            </Label>
          </div>
        )}
        {data.facets?.map((facetSettings, i) => {
          const facet = facetSettings?.field?.value;

          if (!facet) return null;

          return (
            <div key={i}>
              {Object.keys(facets).includes(facet) && !!facets[facet] && (
                <div className="filter-list-group" key={i}>
                  <span className="label-title">
                    {facetSettings.title ?? facetSettings?.field?.label}
                  </span>
                  <Label size="small">
                    <Icon
                      name="delete"
                      onClick={() => {
                        const filteredFacets = Object.assign(
                          {},
                          ...Object.keys(facets)
                            .filter((f) => f !== facet)
                            .map((f) => ({ [f]: facets[f] })),
                        );
                        !isEditMode && setFacets(filteredFacets);
                      }}
                    />
                  </Label>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  ) : null;
};

export default FilterList;
